import { createTheme, ThemeProvider } from "@mui/material/styles";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./components/pages/Home";
import MissionView from "./components/pages/MissionView";
import MissionDetail from "./components/pages/MissionDetail";
import MissionCreate from "./components/pages/MissionCreate";
import MissionEdit from "./components/pages/MissionEdit";
import "./App.css";

// カスタムテーマを作成
const theme = createTheme({
  palette: {
    primary: {
      main: "#4caf50", // ここを好きな色に変更（例: 青）
      contrastText: "#ffffff", // 白文字
    },
    background: {
      default: "#f5f5f5", // 背景色を灰色に設定
      paper: "#ffffff", // カードやダイアログの背景色は白のまま
    },
  },
});

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <div className="centered-container">
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/missions" element={<MissionView />} />
            <Route
              path="/missions/:mission_id/detail"
              element={<MissionDetail />}
            />
            <Route
              path="/missions/:mission_id/edit"
              element={<MissionEdit />}
            />
            <Route path="/missions/new" element={<MissionCreate />} />
          </Routes>
        </Router>
      </div>
    </ThemeProvider>
  );
};

export default App;
